import { render } from "./ApprovedRiderInfo.vue?vue&type=template&id=4fa5166c"
import script from "./ApprovedRiderInfo.vue?vue&type=script&lang=js"
export * from "./ApprovedRiderInfo.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__